<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'configuration.eclairage' | translate"
      [description]="'configuration.eclairageDescription' | translate"
    >
    </app-header-configuration>

    <app-two-choices-control
      [title]="'P00039.parameters.setting.clock' | translate"
      [firstLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.day'
          | translate
      "
      [firstValue]="0"
      [secondLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.week'
          | translate
      "
      [secondValue]="1"
      [value]="actionStack!.getValue('eclairageStandardPHorlogeType')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Eclairage_Parametrage2,
          'eclairageStandardPHorlogeType',
          $event,
          null
        )
      "
    >
    </app-two-choices-control>

    @if (
      this.actionStack!.getValue('eclairageStandardITypeEclairage') === 3 ||
      this.actionStack!.getValue('eclairageStandardITypeEclairage') === 4
    ) {
      @if (this.actionStack!.getValue('eclairageStandardPHorlogeType') === 0) {
        <app-larged-link
          [name]="'P00039.parameters.setting.clockday' | translate"
          (onPress)="goToFunctionParametersSettingsWeltico2ClockScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="'P00039.parameters.setting.clockweek' | translate"
          (onPress)="goToFunctionParametersSettingWeltico2ClockWeekScreen()"
        >
        </app-larged-link>
      }
    } @else {
      @if (this.actionStack!.getValue('eclairageStandardPHorlogeType') === 0) {
        <app-larged-link
          [name]="'P00039.parameters.setting.clockday' | translate"
          (onPress)="goToFunctionParametersSettingsClockScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="'P00039.parameters.setting.clockweek' | translate"
          (onPress)="goToFunctionParametersSettingClockWeekScreen()"
        >
        </app-larged-link>
      }
    }

    <app-label-description
      [description]="'P00039.parameters.setting.text.clock' | translate"
    ></app-label-description>

    <app-switch-configuration
      [title]="'configuration.24h' | translate"
      [nameCustom]="'configuration.activation' | translate"
      [value]="
        actionStack!.getValue('eclairageStandardPActivationExtinction24h') !== 0
      "
      [description]="
        'P00039.parameters.setting.text.extinction.H24' | translate
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Eclairage_Parametrage2,
          'eclairageStandardPActivationExtinction24h',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    <app-switch-configuration
      [title]="'configuration.extinctionAutom' | translate"
      [nameCustom]="'configuration.activation' | translate"
      [value]="
        actionStack!.getValue('eclairageStandardPActivationExtinction') !== 0
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Eclairage_Parametrage2,
          'eclairageStandardPActivationExtinction',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (
      this.actionStack!.getValue('eclairageStandardPActivationExtinction') !== 0
    ) {
      <app-minuterie-label
        [name]="'P00039.parameters.setting.extinction.prog.timer' | translate"
        [value]="
          convertMinutesToTime(
            actionStack!.getValue('eclairageStandardPHeureExtinction')
          )
        "
        [minuteInterval]="30"
        [startDate]="
          this.actionStack!.getValue('eclairageStandardPHeureExtinction')
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Eclairage_Parametrage2,
            'eclairageStandardPHeureExtinction',
            $event,
            null
          )
        "
      >
      </app-minuterie-label>
    }

    <app-label-description
      [description]="'configuration.extinctionAutomHelper' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
